const schemaUrl = 'https://schema.org';
const BreadcrumbSchema = `${schemaUrl}/BreadcrumbList`;
const ListItemSchema = `${schemaUrl}/ListItem`;
const namespace = 'ui-search-breadcrumb';

export { schemaUrl, namespace, BreadcrumbSchema, ListItemSchema };
